import React from 'react';
import classnames from 'classnames';

import { useMenu } from '@ers/hooks';

export default function LayoutContainer({ children }) {
    const { state } = useMenu();
    return <div className={classnames('page', `page${state}`)}>{children}</div>;
}
